import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export default function NotFound() {
  const { t } = useLang();
  return (
    <div className="max-w-[700px] mx-auto px-5 py-28 text-center" data-testid="notfound-page">
      <div className="font-display text-7xl text-gold">404</div>
      <h1 className="font-display text-3xl text-white mt-4">This page took a wrong turn in Dubai.</h1>
      <p className="text-white/60 mt-3">The page you're looking for doesn't exist. Ask BuyDubai AI instead — it'll point you the right way.</p>
      <div className="mt-8 flex items-center justify-center gap-3">
        <Link to="/" className="inline-flex items-center gap-1.5 px-6 py-3 rounded-full border border-white/15 text-white hover:border-gold/40 transition-colors duration-200"><Home size={16} /> Home</Link>
        <Link to="/ask" className="inline-flex items-center gap-1.5 px-6 py-3 rounded-full bg-gold text-ink font-semibold hover:brightness-110 transition-all duration-200">{t("common.ask_ai")} <ArrowRight size={15} /></Link>
      </div>
    </div>
  );
}
